export const resolveSortableInsertionIndicatorZIndex = (baseZIndex: number, surfaceZIndex: number): number =>
    Math.max(baseZIndex, surfaceZIndex) + 1;
